import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getDefaultValues } from '../components/Controls/utils';
import { DEFAULT_CATEGORY, DEFAULT_PRICE } from '../constants';
import { useCalculatorContext } from '../contexts';
export function useCatalogCardClick() {
  var _useCalculatorContext = useCalculatorContext(),
    setSelectedProduct = _useCalculatorContext.setSelectedProduct,
    config = _useCalculatorContext.config,
    setCatalogOpen = _useCalculatorContext.setCatalogOpen,
    products = _useCalculatorContext.products,
    setProducts = _useCalculatorContext.setProducts,
    setSelectedCategory = _useCalculatorContext.setSelectedCategory,
    onProductSelect = _useCalculatorContext.actions.onProductSelect;
  return function (productId) {
    var _products$productId;
    onProductSelect === null || onProductSelect === void 0 ? void 0 : onProductSelect(productId);
    setProducts(function (oldValue) {
      var _oldValue$productId, _config$products$prod, _config$products$prod2;
      return _objectSpread(_objectSpread({}, oldValue), {}, _defineProperty({}, productId, ((_oldValue$productId = oldValue[productId]) !== null && _oldValue$productId !== void 0 ? _oldValue$productId : []).concat([{
        data: _objectSpread(_objectSpread({}, getDefaultValues((_config$products$prod = (_config$products$prod2 = config.products[productId].formConfig) === null || _config$products$prod2 === void 0 ? void 0 : _config$products$prod2.controls) !== null && _config$products$prod !== void 0 ? _config$products$prod : {})), {}, {
          productQuantity: 1
        }),
        price: DEFAULT_PRICE
      }])));
    });
    setSelectedProduct({
      id: productId,
      idx: ((_products$productId = products[productId]) === null || _products$productId === void 0 ? void 0 : _products$productId.length) || 0
    });
    setSelectedCategory(DEFAULT_CATEGORY);
    setCatalogOpen(false);
  };
}